const runtimeConfig = window.Config || {};

const defaultOtelConfig = {
  ENABLED: false,
  EXPORTER_OTLP_ENDPOINT: "",
  SERVICE_NAME: "",
  SERVICE_VERSION: "",
  DEPLOYMENT_ENVIRONMENT: "",
  PROJECT: "",
  HEADERS: {}
};

export const AppConfig = {
  apiUrl: runtimeConfig.API_END_POINT || "",
  otel: {
    ...defaultOtelConfig,

    ...(runtimeConfig.OTEL || {}),

    ENABLED: runtimeConfig.OTEL?.ENABLED ?? runtimeConfig.OTEL_ENABLED ?? defaultOtelConfig.ENABLED,
    EXPORTER_OTLP_ENDPOINT: runtimeConfig.OTEL?.EXPORTER_OTLP_ENDPOINT ?? runtimeConfig.OTEL_EXPORTER_OTLP_ENDPOINT ?? defaultOtelConfig.EXPORTER_OTLP_ENDPOINT,
    SERVICE_NAME: runtimeConfig.OTEL?.SERVICE_NAME ?? runtimeConfig.OTEL_SERVICE_NAME ?? defaultOtelConfig.SERVICE_NAME,
    SERVICE_VERSION: runtimeConfig.OTEL?.SERVICE_VERSION ?? runtimeConfig.OTEL_SERVICE_VERSION ?? defaultOtelConfig.SERVICE_VERSION,
    DEPLOYMENT_ENVIRONMENT: runtimeConfig.OTEL?.DEPLOYMENT_ENVIRONMENT ?? runtimeConfig.OTEL_DEPLOYMENT_ENVIRONMENT ?? defaultOtelConfig.DEPLOYMENT_ENVIRONMENT,
    PROJECT: runtimeConfig.OTEL?.PROJECT ?? runtimeConfig.OTEL_PROJECT ?? defaultOtelConfig.PROJECT,
    HEADERS: runtimeConfig.OTEL?.HEADERS ?? runtimeConfig.OTEL_HEADERS ?? defaultOtelConfig.HEADERS
  }
};